import React from 'react';
import classNames from 'classnames';

import { ReactComponent as ArrowIcon } from 'src/assets/icons/arrow.svg';

import { LOCALES } from 'src/constants';
import type { ArrowButtonProps } from './arrow-button.props';

import './arrow-button.scss';

function ArrowButton({ className, handleButtonClick, modifier }: ArrowButtonProps) {
  return (
    <button
      className={classNames(`arrow-button  arrow-button_${modifier}`, className)}
      aria-label={`${LOCALES.MOVE} ${LOCALES[modifier.toUpperCase() as keyof typeof LOCALES]}`}
      onClick={(evt) => {
        evt.stopPropagation();
        handleButtonClick();
      }}
    >
      <ArrowIcon className="arrow-button__icon" />
    </button>
  );
}

export default ArrowButton;
